import React from "react";
import { Card } from "react-bootstrap";
class CardEx extends React.Component {
    render() {
        return (
            <Card role="button" style={{ color: "black", boxShadow: "0.063em 0.75em 1.563em rgb(0 0 0 / 78%)", position: "relative" }} onClick={this.props.onClick}>
                <Card.Body className="mb-3" style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",   // centers horizontally
                        textAlign: "center"     // centers text
                    }}>
                    <i className={`card-img-top ${this.props.image || "iapp-Blank-file"}`} style={{ color: this.props.imageColor || "black", fontSize: this.props.size || "60px" }} />
                    {this.props.title ? <Card.Title style={{ marginTop: "10px", textAlign: "center", fontSize: "clamp(0.875rem, 0.85vw, 0.25rem)" }}>{this.props.title || ""}</Card.Title> : ``}
                    {this.props.text ? <Card.Text style={{ fontSize: "clamp(0.5rem, 0.3vw, 0.25rem)" }}>{this.props.text || ""}</Card.Text> : ``}
                    {this.props.note ? <Card.Text>
                        <small className="text-muted">{this.props.note}</small>
                    </Card.Text>
                        : ``}
                </Card.Body>
            </Card>
        
        )
    }
}

export default CardEx;